import { Outlet } from 'react-router';

import { RequireAuth } from '@sorare/core/src/routing/RequireAuth';

const SeriesLayout = () => {
  return (
    <RequireAuth>
      <Outlet />
    </RequireAuth>
  );
};

export default SeriesLayout;
